import { render, staticRenderFns } from "./SafeForWorkToggle.vue?vue&type=template&id=62ae3470&"
import script from "./SafeForWorkToggle.vue?vue&type=script&lang=ts&"
export * from "./SafeForWorkToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports